
<template>
    <div class="card-banner w-100 h-100">
        <swiper
            class="w-100 h-100"
            :class="{'swiper-autoplay': swiperData.length > 1, 'swiper-no-autoplay': swiperData.length <= 1}"
            :options="swiperOptions"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        >
            <swiper-slide
                class="w-100 h-100"
                v-for="data in swiperData"
                :key="data.img"
            >
                <b-img
                    :src="data.img"
                    class="h-100 w-100 object-fit-cover"
                />
                <div
                    v-if="data.html"
                    class="position-absolute w-100 h-100"
                    style="left: 0; top: 0;"
                    v-html="data.html"
                >
                </div>
            </swiper-slide>
            <div
                slot="pagination"
                class="swiper-pagination"
            />
        </swiper>
    </div>
</template>

<script>
import { computed, getCurrentInstance } from '@vue/composition-api'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import useAvailableServices from '@/composables/useAvailableServices'
import authConfig from '@/auth/hyper-auth/authConfig.js'
import 'swiper/css/swiper.css'
export default {
    props: ['editMode'],
    components: {
        Swiper,
        SwiperSlide
    },
    setup () {
        const vm = getCurrentInstance().proxy
        const { availableServices } = useAvailableServices()
        const opsDomain = computed(() => availableServices.value.find(service => service.title === 'OPS'))
        const token = localStorage.getItem(authConfig.storageTokenKeyName)
        const swiperOptions = {
            spaceBetween: 30,
            centeredSlides: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        }
        const swiperData = computed(() => [
            {
                img: require('@/assets/images/banner/banner_ops.jpg'),
                html: `<div class="h-100 d-flex flex-column justify-content-between" style="padding: 33px;">
                        <div style="color: white;">
                            <p style="font-size: 3rem; margin-bottom: 21px;" class="line-height-1">Hyper<br/>OPS
                                </p><span class="d-inline-block">${vm.$t('org.dashboard.Cost Optimization Automation Solution')}
                                    <br/>${vm.$t('org.dashboard.Analyze Usage Metrics and Reduce Costs')}<br/>
                                    ${vm.$t('org.dashboard.Predict and Suggest Optimal Instances')}</span></div>
                                    <a href="${opsDomain.value?.domain}/signin/email/${opsDomain.value?.email}/token/${token}" target="_blank" style="color: white; font-size: 1.2rem; ${opsDomain.value ? '' : 'display: none;'}">${vm.$t('org.dashboard.Go to')}<img class="ml-50 mb-25" src="${require('@/assets/images/banner/banner_arrow_right.png')}" style="object-fit: contain"/></a>
                                    </div>`
            }
        ])
        return {
            swiperOptions,
            swiperData
        }
    }
}
</script>

<style>
.card-banner {
    border-radius: 8px;
    overflow: hidden !important;
    background: transparent;
    box-shadow: none;
}
.card-banner .swiper-pagination {
    text-align: right;
    padding-right: 30px;
    padding-bottom: 15px;
}
.card-banner .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    margin: 0 3px !important;
    background: rgb(255, 255, 255, 1) !important;
    opacity: 0.5;
}
.card-banner .swiper-pagination-bullet-active {
    background: rgb(255, 255, 255, 1) !important;
    opacity: 1;
}
.swiper-no-autoplay .swiper-pagination {
    display: none;
}
.object-fit-cover {
    object-fit: cover;
}
</style>
